<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content" style="margin-top: 20px">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="运营商名称">
              <el-input v-model="searchCondition.name" placeholder="输入运营商名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton" :disabled="loadingStaus">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable v-permission="`OperManagement_package_list`" ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"
          highlight-current-row @switchPaging="switchPaging">
          <el-table-column align="center" label="已充值套餐" width="200">
              <template slot-scope="scope">
                  <div v-if="scope.row.in_meal_list.length">
                      <span v-for="(item,index) in scope.row.in_meal_list" :key="item.meal_id">
                        {{item.meal_name}} <span v-if="index<scope.row.in_meal_list.length-1">、</span>
                      </span>
                  </div>
                  <div v-else>
                    -
                  </div>
              </template>
          </el-table-column>
          <el-table-column align="center" label="累计充值套餐包" width="220">
              <template slot-scope="scope">
                  <div v-if="scope.row.meal_list.length">
                    <div v-for="item in scope.row.meal_list" :key="item.meal_id">
                      {{item.meal_name}}: {{item.num}}
                    </div>
                  </div>
                  <div v-else>
                    -
                  </div>
              </template>
          </el-table-column>
          <el-table-column align="center" label="套餐包余量" width="220">
              <template slot-scope="scope">
                  <div v-if="scope.row.surplus_meal_list.length">
                    <div v-for="item in scope.row.surplus_meal_list" :key="item.meal_id">
                      {{item.meal_name}}:{{item.surplus_num}}
                    </div>
                  </div>
                  <div v-else>
                    -
                  </div>
              </template>
          </el-table-column>
          <el-table-column align="center" label="所得收益(元)" width="140">
              <template slot-scope="scope">
                  <div>
                      {{scope.row.profit}}
                  </div>
              </template>
          </el-table-column>
          <el-table-column align="center" label="扣费设定">
            <template slot-scope="scope">
              <el-link type="primary" v-permission="`OperManagement_package_set`" @click="updateSetting(scope.row)">设置
              </el-link>
            </template>
          </el-table-column>
          <el-table-column width="280" align="center" label="操作">
            <template slot-scope="scope">
              <div class="system-recharge">
                <el-button type="success" v-permission="`OperManagement_package_recharge`" @click="setMealClick(scope.row)">套餐充值</el-button>
                <el-button @click="rechargeRecord(scope.row)">充值记录
                </el-button>
                <el-button type="warning" @click="toCustomerDetails(scope.row.id)">客户详情</el-button>
              </div>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <!-- 扣费设定 -->
    <el-dialog :visible.sync="isShowSetting" destroy-on-close width="50%" title="设置" :before-close='beforeClose'>
      <el-form ref="form" label-width="180px">
        <el-form-item required :label="item.lable" v-for="(item,index) in setting.fromData" :key="index">
          <el-input v-model.trim="setting.fromData[index].val" type="text"><template #append>
              {{item.append|| '元/条'}}
            </template></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="settingSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 充值记录 -->
    <el-dialog destroy-on-close :visible.sync="isShowRecord" center width="80%" title="套餐包充值记录">
      <record :id="id" :type='corp_type' v-if="isShowRecord"></record>
    </el-dialog>
    <!-- 套餐充值 -->
    <el-dialog destroy-on-close :visible.sync="isShowSetMeal" width="40%" title="套餐充值">
      <setmeal :id="id" :type='corp_type' @success='successRecharge' @add='addSetmealCilck' @delete='deleteSetmealCilck'
        :setmealArr='setmealArr'></setmeal>
    </el-dialog>
    <!-- 增加套餐 -->
    <el-dialog destroy-on-close :visible.sync="ShowAddSetmeal" center width="50%" title="创建套餐">
      <addSetmeal @success='addSetmealSuccess'></addSetmeal>
    </el-dialog>
    <!-- 删除套餐 -->
    <el-dialog destroy-on-close @close='close' :visible.sync="ShowdeleteSetmeal" center width="50%" title="删除套餐">
      <el-form ref="form" label-width="120px">
        <el-form-item label="请选择删除套餐" required>

          <div class="div-box">
            <div class="system" style="height: 30px;">

            </div>
            <div class="SetmealArr-box">
              <div v-for="item in deleteSetmealArr" class="SetmealArr-box-item" :key="item.s4">
                <el-tag closable effect="dark" v-if="!item.hide" @close='closesetmeal(item)'>
                  {{item.meal_name}}
                </el-tag>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="deleteSetmealSumbit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import PageHeaderLayout from "@/layouts/PageHeaderLayout";
  import ApeTable from "@/components/ApeTable";
  import tzForm from "@/components/tz-form";
  import record from './record.vue'
  import setmeal from './setmeal.vue'
  import addSetmeal from './addSetmeal.vue'
  import reg from '@/utils/reg.js'
  import {
    S4
  } from '@/utils/utils.js'
  import {
    mapGetters
  } from "vuex";
  export default {
    components: {
      setmeal,
      record,
      tzForm,
      PageHeaderLayout,
      ApeTable,
      addSetmeal
    },
    data() {
      return {
        setmealArr: [],
        deleteSetmealArr: [],
        deleteSetmealArrID: [],
        id: '', //当前选择的公司
        isShowSetting: false,
        isShowSetMeal: false, //套餐充值
        ShowAddSetmeal: false, //增加套餐
        ShowdeleteSetmeal: false, //删除套餐
        isShowRecord: false,
        searchCondition: {
          name: ''
        },
        //费用明细
        info_money: {},
        setting: {
          fromData: [{
              lable: '短信认证签约：',
              val: '',
              filed: 'esignsms_money'
            },
            {
              lable: '人脸识别认证签约：',
              val: '',
              filed: 'esignface_money'
            },
            {
              lable: '银行卡四要素认证签约：',
              val: '',
              filed: 'esignbank_money'
            },
            {
              lable: '智能算税：',
              val: '',
              filed: 'tax_money'
            },
            {
              lable: '短信通知类：',
              val: '',
              filed: 'sms_money',
              append: '元/条'
            },
            {
              lable: '自定义电子合同：',
              val: '',
              filed: 'cont_money',
              append: "元/份",
            },
            {
              lable: '管理员角色：',
              val: '',
              filed: 'adm_money'
            },
            {
              lable: '人才库：',
              val: '',
              filed: 'pool_money',
              append: '元/人/年'
            },
            {
              lable: '人才库免费人数：',
              val: '',
              filed: 'free_pool_number',
              append: "人",
            },
          ]
        },
        loadingStaus: false,
        corp_type: '3',
        // 分页信息
        pagingData: {
          is_show: true,
          layout: "total, sizes, prev, pager, next, jumper",
          total: 0,
        },
        dataList: [],
        columns: [{
            title: "运营商名称",
            value: "name",
            header_align: "center",
            align: "center",
            width:140
          }
        ],
      };
    },

    methods: {
      // 公司详情
      toCustomerDetails(id) {
        if (!id) return;
        this.$router.push({
          path: "operator_package/details",
          query: {
            id: id
          }
        })
      },
      //套餐充值
      async setMealClick(row) {
        this.id = row.id
        await this.getSetmealList()
        this.isShowSetMeal = true

      },
      //增加套餐
      addSetmealCilck() {

        this.ShowAddSetmeal = true
      },
      //增加套餐成功
      addSetmealSuccess() {

        this.ShowAddSetmeal = false
        this.getSetmealList()
      },
      //删除套餐
      deleteSetmealCilck() {
        this.ShowdeleteSetmeal = true
      },
      //删除套餐提交
      async deleteSetmealSumbit() {
        const res = await this.$api.postdelSetMealID({
          id: this.deleteSetmealArrID
        })
        console.log(res)
        this.ShowdeleteSetmeal = false
        this.getSetmealList()

      },
      //删除套餐关闭
      close() {
        this.deleteSetmealArr = this.setmealArr.map((item) => {
          item.s4 = S4()
          return item
        })
        this.deleteSetmealArrID = []

      },
      //删除套餐tag
      closesetmeal(value) {

        this.deleteSetmealArr = this.deleteSetmealArr.filter((item) => {

          return item.id != value.id
        })
        this.deleteSetmealArrID.push(value.id)
        // this.deleteSetmealArrID.push(value.id)
      },
      //充值成功回掉
      successRecharge(name) {
        this[name] = false
        this.init()
      },
      //获取套餐列表
      async getSetmealList() {
        const res = await this.$api.postSet_mealTagList()

        this.setmealArr = res.data || []
        this.deleteSetmealArr = res.data || []
        this.deleteSetmealArr = this.deleteSetmealArr.map((item) => {

          item.s4 = S4()
          return item
        })

        console.log(this.setmealArr)
      },
      async settingSubmit() {
        //校验格式
        for (let item of this.setting.fromData) {

          if (!reg?.money.test(item.val)) {
            return this.$message.error(item.lable + '金额格式不正确')
          }
        }

        //获取表单的值
        let fromData = {}
        for (let item of this.setting.fromData) {
          fromData[item.filed] = item.val
        }
        //请求
        let res = await this.$api.postSettingRecharge({
          company_id: this.id,
          company_type: this.corp_type,
          ...fromData
        })
        if (res) {
          this.isShowSetting = false
          this.init()
        }

      },
      beforeClose(done) {
        //关闭清空表单值
        this.setting.fromData.map((item) => {
          item.val = ''
        })
        done && done()
      },
      //查询单次费用
      async getRechageSetRecord() {
        let res = await this.$api.postOneRechargeRecord({
          company_id: this.id,
          company_type: this.corp_type,
        })
        this.info_money = res
        this.setting.fromData.map((item) => {
          item.val = res[item.filed] || ''
          return item
        })

        console.log(this.setting.fromData)
      },

      async updateSetting(row) {
        this.id = row.id
        this.isShowSetting = true
        this.getRechageSetRecord()
      },
      rechargeRecord(row) {
        this.id = row.id
        this.isShowRecord = true
      },


      // 重置分页
      async resetPage() {
        this.$refs.apeTable.currentPage = 1;
      },
      // 切换页码操作
      async switchPaging() {
        this.init();
      },
      //查询	
      searchButton() {
        this.resetPage()
        this.init()
      },
      //获取列表
      async init() {
        let pagingInfo = this.$refs['apeTable']?.getPagingInfo() || {
          page_size: 10,
          current_page: 1
        }
        this.loadingStaus = true;
        let res = await this.$api.getPackageOperatorManageList({
          // company_type: this.corp_type,
          ...pagingInfo,
          ...this.searchCondition
        })
      
        // 处理套餐包列表
        let dataList = [];
        if(res.data.length){
          res.data.map(item=>{
            let surplus_meal_list = [];
            let in_meal_list = [];
            if(item.meal_list.length){
              item.meal_list.map(item1=>{
                if(Number(item1.surplus_num)>0){
                  surplus_meal_list.push(item1)
                }
                if(Number(item1.num)>0){
                  in_meal_list.push(item1)
                }
              })
            }
            item.surplus_meal_list = surplus_meal_list;
            item.in_meal_list = in_meal_list;
            dataList.push(item)
          })
        }
        this.dataList = dataList
        this.pagingData.total = res.pages.total
        this.loadingStaus = false;
      },

    },
    computed: {
      ...mapGetters(["userPermissions"]),
    },

    mounted() {
      this.init()
    },
  };
</script>

<style lang="scss" scoped>
  .system-recharge {
    display: flex;
    justify-content: space-around;
  }

  .el-button {
    margin-right: 4px;
    margin-bottom: 4px;
  }

  .SetmealArr-box {
    display: flex;
    flex-wrap: wrap;

    .SetmealArr-box-item {
      margin-right: 6px;
    }
  }
</style>
